export default {
  swapDeleteConfirmationCancel: {
    id: 'swap_cart_delete_cancel',
    defaultMessage: 'Cancel',
  },
  swapDeleteConfirmationCancelAnytimeTitle: {
    id: 'swap_cart_delete_title_cancel',
    defaultMessage: 'Remove trade-in?',
  },
  swapDeleteConfirmationCancelAnytimeBody: {
    id: 'swap_cart_delete_description_cancel',
    defaultMessage:
      'You have 21 days to ship your device. If you change your mind, simply keep it and your trade-in will be automatically cancelled.',
  },
  swapDeleteConfirmationCancelAnytimeRemoveLabel: {
    id: 'swap_cart_delete_valid_cancel',
    defaultMessage: 'Remove anyway',
  },
}
